module.exports = __webpack_public_path__ + "static/app4-0ebe271b91ab5fde888eb246b687bd6d.png";